// Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
import axios from '../../libs/cifra/axios';

export default {
  get(id, options) {
    const opts = options || {};
    const defaults = { id };
    opts.params = Object.assign(defaults, opts.params);
    return axios.get('/gestion_economica/generar_suscripciones/json', opts);
  },
};
